// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__P99sD","header":"MessagesList_header__3EOM0","chat":"MessagesList_chat__1L7va"};